import { getTermValue } from '@/packages/JsonQuery';

import { type ITagGroupConfig } from '../types';

export const hiddenBase: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermValue('is_in_hidden_base')(jsonQuery);
    if (!value) {
      return null;
    }

    return [
      {
        group: 'hiddenBase',
        text: 'Только видимые агентам',
      },
    ];
  },
  delete({ onChange }) {
    onChange({
      action: 'setHiddenBaseSearch',
      arguments: [null],
    });
  },
};
